import React, { useContext, useEffect, useState } from "react";
import * as PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { deleteQueueItem, releaseQueueItem } from "../../../Queries/Mutations";
import RequirementsWorkflowDisplay from "../../../Display/DataEntry/DataEntryThree_RequirmentsWorkflow/RequirementsWorkflowDisplay";
import HeaderTitleContext from "../../../Context/HeaderTitleContext";
import MainContentWidthContext from "../../../Context/MainContentWidthContext";
import {getClaimedQueueItems} from "../../../Queries/Queries";

const RequirementsWorkflowContainer = () => {
  let location = useLocation();
  const lastStep = 4;
  const [data, setData] = useState(
    location.state.data ? location.state.data : {}
  );
  // eslint-disable-next-line no-unused-vars
  const [steps, setSteps] = useState([
    "Footnotes",
    "Requirements",
    "Requirements Matrix",
    "Requirements 2",
    "Requirements Matrix 2",
  ]);
  const [step, setStep] = useState(0);
  const [renderKey, setRenderKey] = useState(0);
  const [documentsOpen, setDocumentsOpen] = useState(false);
  const history = useHistory();

  // eslint-disable-next-line no-unused-vars
  const [headerTitle, setHeaderTitle] = useContext(HeaderTitleContext);

  if (step > steps.length) {
    setStep(steps.length);
  }

  // eslint-disable-next-line no-unused-vars
  const [releaseJurisdiction, { data: releasedJurisdiction }] = useMutation(
    releaseQueueItem("requirements_workflow", data.id), {refetchQueries: [{query: getClaimedQueueItems('requirements_workflow'), variables: {queue: 'requirements_workflow'}}]}
  );
  const [removeJurisdiction, { data: removedJurisdiction }] = useMutation(
    deleteQueueItem("requirements_workflow", data.id), {refetchQueries: [{query: getClaimedQueueItems('requirements_workflow'), variables: {queue: 'requirements_workflow'}}]}
  );

  useEffect(() => {
    if (releasedJurisdiction) {
      history.push({
        pathname: "/data_entry/requirements_workflow",
      });
    }
  }, [releasedJurisdiction]);

  useEffect(() => {
    if (removedJurisdiction) {
      history.push({
        pathname: "/data_entry/requirements_workflow",
      });
    }
  }, [removedJurisdiction]);

  // use this to make sure the render key never repeats when the step changes
  const setActiveStep = (step) => {
    setStep(step);
    setRenderKey(renderKey + 1);
  };

  // eslint-disable-next-line no-unused-vars
  const [mainContentWidth, setMainContentWidth] = useContext(
    MainContentWidthContext
  );

  switch (step) {
    case 1:
      setMainContentWidth("80");
      break;
  }

  return (
    <RequirementsWorkflowDisplay
      data={{ get: data, set: setData }}
      steps={steps}
      step={{ get: step, set: setActiveStep }}
      releaseJurisdiction={releaseJurisdiction}
      removeJurisdiction={removeJurisdiction}
      renderKey={renderKey}
      lastStep={lastStep}
      width="80"
      setHeaderTitle={setHeaderTitle}
      documentsOpen={{ get: documentsOpen, set: setDocumentsOpen }}
    />
  );
};

RequirementsWorkflowContainer.propTypes = {
  data: PropTypes.any,
};

export default RequirementsWorkflowContainer;
